import { useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';
import {
	BaseButton,
	type BaseButtonProps,
} from '~/_shared/design-system/ui/atoms/button/base/base-button';

import './text-button.css';

type TextButtonProps = BaseButtonProps;

const TextButton = ({ className, id, ...rest }: TextButtonProps) => {
	// Instance-unique default id (explicit `id` prop wins) — see BaseButton.
	const auto_id = useId();
	return (
		<BaseButton
			{...rest}
			id={id ?? `TextButton-${auto_id}`}
			className={classlist('text-button', className)}
		/>
	);
};

export type { TextButtonProps };
export { TextButton };
